export interface ScannedProduct {
  title: string
  editionLabel?: string
  priceNumber: number
  priceText: string
  thumbnailUrl?: string
}

const FALLBACK_PRODUCTS: ScannedProduct[] = [
  {
    title: 'Cenas Antiinflamatorias',
    editionLabel: 'Pack Completo',
    priceNumber: 499.0,
    priceText: '$499 MXN',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png',
  },
  {
    title: 'Cenas Antiinflamatorias',
    editionLabel: 'Pack Antiinflamatorio',
    priceNumber: 367.0,
    priceText: '$367 MXN',
    thumbnailUrl:
      'https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png',
  },
]

export function scanProducts(): ScannedProduct[] {
  if (typeof document === 'undefined') return FALLBACK_PRODUCTS

  const products: ScannedProduct[] = []

  // 1. Try JSON-LD
  try {
    const scripts = document.querySelectorAll(
      'script[type="application/ld+json"]',
    )
    scripts.forEach((script) => {
      const data = JSON.parse(script.textContent || '{}')
      const items = Array.isArray(data) ? data : [data]

      items.forEach((item) => {
        if (item['@type'] === 'Product' || item['@type'] === 'Offer') {
          const price = item.offers?.price || item.price
          if (price) {
            products.push({
              title: item.name || 'Cenas Antiinflamatorias',
              priceNumber: parseFloat(price),
              priceText: `${price}`,
              thumbnailUrl: item.image || undefined,
            })
          }
        }
      })
    })
  } catch (e) {
    // Ignore JSON parse errors
  }

  // 2. DOM scanning for prices if JSON-LD found nothing
  if (products.length === 0) {
    // Look for elements with our specific dollar format: "$367 MXN" or "$499 MXN"
    const priceRegex = /\$\s*(\d+(?:,\d{2})?)/

    // Scan specific known containers first (like pricing boxes)
    const pricingBoxes = document.querySelectorAll(
      '.bg-white.rounded-2xl.p-6.shadow-lg.border-2.border-gold',
    )

    pricingBoxes.forEach((box) => {
      const text = box.textContent || ''
      const match = text.match(priceRegex)
      if (match) {
        const priceStr = match[1].replace(',', '.')
        const priceNum = parseFloat(priceStr)

        // Find nearest image
        const img = document.querySelector(
          'img[src*="mockup"]',
        ) as HTMLImageElement

        products.push({
          title: 'Cenas Antiinflamatorias',
          editionLabel:
            priceNum > 20 ? 'Pack Completo' : 'Pack Antiinflamatorio',
          priceNumber: priceNum,
          priceText: match[0],
          thumbnailUrl:
            img?.src ||
            'https://cdn.magicpatterns.com/uploads/rdHi3rAEoBrUtDvyQN1xfL/mockup_cenas_antiinf15.png',
        })
      }
    })
  }

  // 3. Fallback
  if (products.length === 0) {
    return FALLBACK_PRODUCTS
  }

  return products
}

export function getRandomProduct(
  catalog: ScannedProduct[] = FALLBACK_PRODUCTS,
): ScannedProduct {
  if (catalog === FALLBACK_PRODUCTS) {
    // 70% Pack Completo, 30% Pack Antiinflamatorio
    return Math.random() < 0.7 ? catalog[0] : catalog[1]
  }

  const index = Math.floor(Math.random() * catalog.length)
  return catalog[index]
}
